import React from 'react';
import { LTTestStatusLabel } from '@lambdatestincprivate/lt-components';
import { getStatusIconAndClassPrefix } from '../../utils/statusOptions';

const TIMEOUT_BG = '#FF5D2A';

const RCAStatusIcon = ({ status }) => {
  if (!status) return null;

  const normalizedStatus = status === 'lambda_error' ? 'lambda error' : status;
  const isTimeout = status === 'timeout';
  const { statusIconName } = getStatusIconAndClassPrefix(normalizedStatus);

  if (!statusIconName) return null;

  if (isTimeout) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: TIMEOUT_BG,
          padding: '2px',
        }}
      >
        <img
          alt="test-status"
          src={statusIconName}
          width={16}
          height={16}
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </span>
    );
  }

  return (
    <LTTestStatusLabel
      iconSrc={statusIconName}
      status={normalizedStatus}
      showStatusText={false}
      width={16}
      height={16}
    />
  );
};

export default RCAStatusIcon;
